module.exports = __webpack_public_path__ + "img/dots.6584b5c6.svg";